// extracted by mini-css-extract-plugin
export default {"imageSample":"GalleryPage_imageSample__17lKk"};